import { useContext, useEffect, useState } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
import Icon_Down from '../../Assets/Icons/Icon_Arrow_Down.png';

export default function UI_Dropdown_New({
    id,
    InitialTitle = "Select...",
    Items = [],
    Selected = null,
    Fill = false,
    Label_Text,
    Item_Key = "Name", // Default key used to display text
    Required = false,
    onSelect,
    className
}) {
    const UI = useContext(Context_UI);
    const [State, State_Set] = useState("Inactive");
    const [SelectedItem, SetSelectedItem] = useState(Selected);

    const SelectedText = SelectedItem
        ? SelectedItem[Item_Key] || "Unnamed item"
        : InitialTitle;

    const Toggle = () => {
        if (State === "Active") {
            State_Set("Animating");
            UI.Dropdown_ToggleList(id);
            setTimeout(() => State_Set("Inactive"), 300);
        } else if (State === "Inactive") {
            State_Set("Active");
            UI.Dropdown_ToggleList(id);
        }
    };

    // Sync with external Selected prop
    useEffect(() => {
        if (Selected && Selected !== SelectedItem) {
            SetSelectedItem(Selected);
        }
    }, [Selected]);

    const Handle_Select = (Item, Index) => {
        Toggle();
        SetSelectedItem(Item);
        if (typeof onSelect === "function") onSelect(Item, Index);
    };

    return (
        <>
            {Label_Text && (
                <label className="Input_Label" htmlFor={id}>
                    {Label_Text}
                    {Required && <p className="Input_Label_Required">*</p>}
                </label>
            )}

            <div
                className={`Dropdown ${className || ''}`}
                id={id}
                State={State === "Active" || State === "Animating" ? "Active" : "Inactive"}
                Fill_Horizontal={Fill ? "true" : null}
            >
                <button
                    type="button"
                    className="Dropdown_Button"
                    onClick={Toggle}
                    Fill_Horizontal={Fill ? "true" : null}
                >
                    <span className="Dropdown_Button_Text">
                        {SelectedText}
                    </span>
                    <img
                        className="Dropdown_Button_Arrow"
                        src={Icon_Down}
                        draggable="false"
                        loading="lazy"
                    />
                </button>

                {(State === "Active" || State === "Animating") && (
                    <div className="Dropdown_List">
                        {Items.length > 0 ? (
                            Items.map((Item, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    className="Dropdown_List_Item"
                                    onClick={() => Handle_Select(Item, index)}
                                >
                                    {Item[Item_Key] || `Item ${index + 1}`}
                                </button>
                            ))
                        ) : (
                            <div className="Dropdown_List_Item Disabled">No items</div>
                        )}
                    </div>
                )}

                <p className="Dropdown_Prompt" id={`${id}_Prompt`} />
            </div>
        </>
    );
}
